// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pPMf","content":"styles_content__L3Xkm","row":"styles_row__xR4S8","footer":"styles_footer__YiLIF","phraseLength":"styles_phraseLength__1CjlP"};